import { render, staticRenderFns } from "./MoneyValue.vue?vue&type=template&id=32dde670&lang=pug&"
import script from "./MoneyValue.vue?vue&type=script&lang=ts&"
export * from "./MoneyValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports